import React, { useRef } from 'react';
import styles from './index.module.scss';
import { images } from 'utils/icons';
import Image from 'components/Image';
import PropTypes from 'prop-types';

const downloadMedia = url => {
  window.open(url);
};

const ReactAudioPlayer = ({ base64Audio, autoPlay, controls = true }) => {
  const musicRef = useRef(null);
  return (
    <div className={styles.mediaPlayer}>
      <Image src={images.audioMedia.default} className={styles.mediaImage} />
      <audio
        ref={musicRef}
        className={styles.audio}
        controls={controls}
        autoPlay={autoPlay}
      >
        <source src={base64Audio} type="audio/mpeg" />
        <Image src={images.downloadMedia.default} onClick={downloadMedia}>
          This browser does not support the HTML5 video element.
        </Image>
      </audio>
    </div>
  );
};

ReactAudioPlayer.defaultProps = {
  autoPlay: false,
};

ReactAudioPlayer.propTypes = {
  base64Audio: PropTypes.string,
  autoPlay: PropTypes.bool,
  controls: PropTypes.bool,
};
export default ReactAudioPlayer;
